import React from "react";

/**
 * Skeleton placeholder matching BalanceSheetMetricCard layout (label, value, trend).
 */
export function BalanceSheetMetricCardSkeleton() {
  return (
    <div className="flex h-full min-h-[156px] grow shrink-0 basis-0 flex-col items-start rounded-xl border border-solid border-neutral-200 bg-white px-5 py-4 shadow-sm">
      <div
        className="animate-pulse rounded bg-neutral-200"
        style={{ height: 16, width: 120 }}
        aria-hidden
      />
      <div
        className="mt-1 animate-pulse rounded bg-neutral-200"
        style={{ height: 12, width: 140 }}
        aria-hidden
      />
      <div
        className="mt-4 animate-pulse rounded bg-neutral-200"
        style={{ height: 34, width: 110 }}
        aria-hidden
      />
      <div className="mt-auto pt-3">
        <div
          className="animate-pulse rounded bg-neutral-200"
          style={{ height: 22, width: 150, borderRadius: 9999 }}
          aria-hidden
        />
      </div>
    </div>
  );
}
